var _path, _ellipse, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEggSaltWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 46,
    viewBox: "0 0 34 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6736 21.3133C31.7438 7.51333 22.9438 0 17 0C11.0562 0 2.25619 7.51333 0.32637 21.3133C-1.52626 35.1133 4.57197 46 17 46C29.428 46 35.5263 35.1133 33.6736 21.3133Z",
    fill: "url(#paint0_radial_10256_11687)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17,
    cy: 32.9216,
    rx: 10.7368,
    ry: 10.3725,
    fill: "url(#paint1_radial_10256_11687)",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10256_11687",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17 23) rotate(90) scale(23 17)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F2DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFECB1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_10256_11687",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17 32.9216) rotate(90) scale(10.3725 10.7368)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#F69517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDE7A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEggSaltWater);
export default __webpack_public_path__ + "static/media/egg_salt_water.53ad8f28797ae9edb64d15bb04211960.svg";
export { ForwardRef as ReactComponent };